import React from 'react';
import TESTIMONIALS from '../data/testimonials';

const Testimonial = props => {
    const {name, position, organization, testimonial, id, website} = props.testimonial;
    return (
       <div>
           <div className="testimonial" id={id}>
                <p>{testimonial}</p>
                <a href={website} target="new"><h2 id="org">{organization}</h2>
                <h2 id="name_position">{name}, {position}</h2></a>
                
           </div>
           <br />
       </div>
    )

}

const Testimonials = () => (
    <div>
        <h1 className="testimonial_header">Testimonials</h1>
        <div className="testimonial_section" id="testimonials">
            {
                TESTIMONIALS.map(TESTIMONIAL => {
                    return (
                        <Testimonial key={TESTIMONIAL.id} testimonial={TESTIMONIAL} />
                    );
                })
            }
            
        </div>
        <hr />
    </div>
)

export default Testimonials;